/* eslint-disable camelcase */
import React from 'react';
// MATERIAL-UI
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core';
// REDUX
import { useSelector } from 'react-redux';
// CLSX
import clsx from 'clsx';
// ICONS
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
// STYLES
import styles from './style';

const Faq = () => {
  const classes = styles();
  const partnerData = useSelector((state) => state.PartnerStoreReducer);
  const { branch } = partnerData;
  const { branch_name } = branch;
  return (
    <div id="answers" className={classes.backgroundTheme}>
      <div className={classes.root}>
        <Typography
          className={clsx(classes.title, {
            [classes.titleCarrefour]: branch_name === 'Carrefour',
            [classes.titleReparofone]: branch_name === 'Limelocker',
          })}
        >
          Você está com alguma dúvida?
        </Typography>
        <Accordion className={classes.accordion} defaultExpanded>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography
              className={clsx(classes.heading, {
                [classes.headingCarrefour]: branch_name === 'Carrefour',
                [classes.headingReparofone]: branch_name === 'Limelocker',
              })}
            >
              Como eu confiro o pré-orçamento?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              className={clsx(classes.answer, {
                [classes.answerCarrefour]: branch_name === 'Carrefour',
                [classes.answerReparofone]: branch_name === 'Limelocker',
              })}
            >
              Para estimar um pré-orçamento para seu aparelho, <a href='#do-estimate'>acesse</a> e
              selecione o modelo, cor e defeito que está sendo apresentado -
              pode ser mais de um defeito, após isso basta clicar em "estimar
              orçamento" para visualizar o valor. O orçamento poderá sofrer
              variação após diagnóstico, mas fique tranquilo você será acionado
              para aprovação. Consulte mais informações no termo de serviço.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel2a-content"
            id="panel2a-header"
          >
            <Typography
              className={clsx(classes.heading, {
                [classes.headingCarrefour]: branch_name === 'Carrefour',
                [classes.headingReparofone]: branch_name === 'Limelocker',
              })}
            >
              Como solicitar a coleta?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              className={clsx(classes.answer, {
                [classes.answerCarrefour]: branch_name === 'Carrefour',
                [classes.answerReparofone]: branch_name === 'Limelocker',
              })}
            >
              Após aceitar o orçamento, complete seus dados, selecione a forma
              como deseja enviar o aparelho de acordo com sua região. São Paulo
              e região metropolitana, nós vamos retirar em sua casa. Caso seja
              de outra região também poderá optar por nos enviar via Correios
              (geramos o código de postagem com custo) ou pela Transportadora
              DHL.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="product-return"
            id="product-return"
          >
            <Typography
              className={clsx(classes.heading, {
                [classes.headingCarrefour]: branch_name === 'Carrefour',
                [classes.headingReparofone]: branch_name === 'Limelocker',
              })}
            >
              Como o aparelho retornará ao meu endereço?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              className={clsx(classes.answer, {
                [classes.answerCarrefour]: branch_name === 'Carrefour',
                [classes.answerReparofone]: branch_name === 'Limelocker',
              })}
            >
              O retorno do aparelho se dará pelo mesmo meio de transporte
              escolhido na coleta, sendo as opções: Transportadora Trocafone,
              DHL e Correios
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="payment-gateway"
            id="payment-gateway"
          >
            <Typography
              className={clsx(classes.heading, {
                [classes.headingCarrefour]: branch_name === 'Carrefour',
                [classes.headingReparofone]: branch_name === 'Limelocker',
              })}
            >
              Quais são as formas de pagamento?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              className={clsx(classes.answer, {
                [classes.answerCarrefour]: branch_name === 'Carrefour',
                [classes.answerReparofone]: branch_name === 'Limelocker',
              })}
            >
              Contamos com as seguintes formas de pagamento: Boleto; Débito pelo
              Mercado Pago; PIX; ou até 12x SEM JUROS no Cartão de Crédito.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="prepare-product-for-collect"
            id="prepare-product-for-collect"
          >
            <Typography
              className={clsx(classes.heading, {
                [classes.headingCarrefour]: branch_name === 'Carrefour',
                [classes.headingReparofone]: branch_name === 'Limelocker',
              })}
            >
              Como preparar o aparelho para coleta?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              className={clsx(classes.answer, {
                [classes.answerCarrefour]: branch_name === 'Carrefour',
                [classes.answerReparofone]: branch_name === 'Limelocker',
              })}
            >
              É importante que você faça uma cópia dos dados e arquivos do seu
              aparelho, antes de enviá-lo. Retirar todos os acessórios como
              Capinha, Chip, Cartão de Memória SD e caixa do aparelho, para
              evitar perdas durante o processo de reparo. Em alguns reparos, há
              riscos de perder toda informação contida no aparelho, por isso é
              recomendado fazer um backup dos arquivos em nuvem ou qualquer
              outro meio de sua preferência. Atenção: A Trocafone não se
              responsabiliza pela perda de dados.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="warranty"
            id="warranty"
          >
            <Typography
              className={clsx(classes.heading, {
                [classes.headingCarrefour]: branch_name === 'Carrefour',
                [classes.headingReparofone]: branch_name === 'Limelocker',
              })}
            >
              Tem garantia depois do reparo?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              className={clsx(classes.answer, {
                [classes.answerCarrefour]: branch_name === 'Carrefour',
                [classes.answerReparofone]: branch_name === 'Limelocker',
              })}
            >
              Sim, nossa garantia é de 90 (noventa) dias, sobre o reparo
              realizado.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="safety"
            id="safety"
          >
            <Typography
              className={clsx(classes.heading, {
                [classes.headingCarrefour]: branch_name === 'Carrefour',
                [classes.headingReparofone]: branch_name === 'Limelocker',
              })}
            >
              A Reparofone é Segura?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              className={clsx(classes.answer, {
                [classes.answerCarrefour]: branch_name === 'Carrefour',
                [classes.answerReparofone]: branch_name === 'Limelocker',
              })}
            >
              Contamos com a qualidade de reparo e os padrões de Segurança da
              Trocafone, assim como também ao coletar seu aparelho você receberá
              um comprovante assinado assegurando que a coleta/entrega foi
              realizada. Somos uma empresa confiável e segura para realizar seus
              reparos, inclusive uma das maiores assistências multimarcas do
              Brasil, com um dos menores preços do mercado e com uma grande
              variedade de modelos e marcas atendidas.
            </Typography>
          </AccordionDetails>
        </Accordion>
        <Accordion className={classes.accordion}>
          <AccordionSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="extravio"
            id="extravio"
          >
            <Typography
              className={clsx(classes.heading, {
                [classes.headingCarrefour]: branch_name === 'Carrefour',
                [classes.headingReparofone]: branch_name === 'Limelocker',
              })}
            >
              E se meu aparelho extraviar no transportador?
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Typography
              className={clsx(classes.answer, {
                [classes.answerCarrefour]: branch_name === 'Carrefour',
                [classes.answerReparofone]: branch_name === 'Limelocker',
              })}
            >
              Se infelizmente vier a ocorrer extravios do aparelho, iremos te
              ressarcir com um aparelho seminovo da Trocafone da mesma condição
              e assegurado com 3 meses de garantia; Será pago pelo cliente
              apenas o valor referente ao reparo que seria realizado.
            </Typography>
          </AccordionDetails>
        </Accordion>
      </div>
    </div>
  );
};

export default Faq;
